module.exports = __webpack_public_path__ + "assets/cfd0cdbb158d63ff1da3c2bc492d431d.mp3";